export function normalizeSummaryDate(summaryDate: string) {
  return new Date(`${summaryDate}T00:00:00`)
}

export function isFromMostRecentFriday(date: Date) {
  const today = new Date()

  // Find the most recent Friday (could be today if it's Friday)
  const mostRecentFriday = new Date(today)
  const diff = (today.getDay() - 5 + 7) % 7 // 5 = Friday
  mostRecentFriday.setDate(today.getDate() - diff)

  // Compare year/month/day only
  return (
    date.getFullYear() === mostRecentFriday.getFullYear() &&
    date.getMonth() === mostRecentFriday.getMonth() &&
    date.getDate() === mostRecentFriday.getDate()
  )
}

export function isDayYesterday(dateToCheck: Date) {
  // Get today's date and set its time to midnight
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  // Get the date to check and set its time to midnight
  const checkedDate = new Date(dateToCheck) // Create a new Date object to avoid modifying the original
  checkedDate.setHours(0, 0, 0, 0)

  // Calculate the date for yesterday at midnight
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)

  // Compare the timestamps (milliseconds since epoch)
  return checkedDate.getTime() === yesterday.getTime()
}

export function isDayToday(dateToCheck: Date) {
  // Get today's date and set its time to midnight
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  // Get the date to check and set its time to midnight
  const checkedDate = new Date(dateToCheck) // Create a new Date object to avoid modifying the original
  checkedDate.setHours(0, 0, 0, 0)

  // Compare the timestamps (milliseconds since epoch)
  return checkedDate.getTime() === today.getTime()
}
